module.exports = __webpack_public_path__ + "images/d1a383c80eec0dc8d0906cc6df3a60ea.png";